import { Button, TextField, Modal, Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import DefaultHeading from '../../components/heading/DefaultHeading';
import { Cron } from 'react-js-cron';
import 'react-js-cron/dist/styles.css';
import 'antd/dist/reset.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from '../../services/networkService';
import { Loader } from '../loader/Loader';
import { openPopup } from '../../stateManagement/actions/popupActions';
import isValidCronExpression from 'cron-validate';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';

const JobsConfigurationSchedularForm = () => {
    const navigate = useNavigate();
    const [showEditTimeForm, setEditTimeForm] = useState(false);
    const [cronExpression, setCronExpression] = useState<string>('0 * * * *');
    const [formData, setFormData] = useState<Record<string, any>>({ "attributes": {} });
    const [isLoading, setLoading] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [jsonString, setJsonString] = useState<string>();
    const getData = async (jobId: any) => {
        setLoading(true);
        try {
            const url = `/jenkins?filter=id:${jobId}`
            const response = await ChannelkartNetworkGet(url);
            setFormData({
                jobName: response?.data?.features[0].jobName,
                taskId: response?.data?.features[0].taskId,
                triggerTime: response?.data?.features[0].triggerTime,
                attributes: response?.data?.features[0].attributes,
                discription: response?.data?.features[0].discription,
            })
            setJsonString(JSON.stringify(response?.data?.features[0].attributes, null, 2))
            setCronExpression(response?.data?.features[0].triggerTime);
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    const query = useQuery();
    const formType = query.get('type');

    useEffect(() => {
        if (formType === "edit") {
            let id = query.get('job');
            getData(id)
        }
    }, []);

    const handleCreate = async () => {
        if (isValid && formData.triggerTime) {
            try {
                const parseAttributes = JSON.parse(jsonString || "{}");
                if (typeof parseAttributes === "string") {
                    openPopup("Alert", `Please fill valid Attributes`);
                } else if (!formData.jobName || !formData.taskId) {
                    openPopup("Alert", `Please fill missing fields`);
                } else {
                    const url = "/jenkins";
                    const operation=formType=="edit"?"Updated":"Created";
                    const method=formType=="edit"?"PUT":"POST";
                    validateWithOtp((verifyUser,verifyResponse)=>{
                        if (verifyResponse && verifyResponse.status === 201 && verifyResponse.status === 200) {
                            openPopup("Success", `${operation} Successfully`);
                            navigate(`/dashboard/jobsConfiguration`);
                        }else if (!verifyResponse || (verifyResponse.status !== 200 && verifyResponse.status !== 201)) {
                            throw new Error("OTP validation failed");
                        }else{
                            throw new Error("API call failed");
                        }
                    },[],"admin",url,formData,method);

                }
            } catch (e) {
                if (e instanceof SyntaxError) {
                    openPopup("Alert", `Please fill valid Attributes`);
                } else {
                    console.error(e);
                }
            }
        } else {
            openPopup("Alert", `Please fill valid Trigger Time`);
        }
    };

    const handleEditTime = () => {
        setEditTimeForm(true);
    }

    const timeEditConfirm = () => {
        setFormData((prevData) => ({
            ...prevData,
            ["triggerTime"]: cronExpression,
        }));
        setEditTimeForm(false);
    };

    const handleClose = () => {
        setEditTimeForm(false);
    };

    function convertCronToLocale(utcCron: string) {
        if (utcCron !== undefined && utcCron !== null) {
            const validationResult = isValidCronExpression(utcCron);
            if (validationResult !== undefined && !validationResult.isValid) {
                const [utcMin, utcHour, dayOfMonth, month, dayOfWeek] = utcCron.split(' ');
                const utcDate = new Date(Date.UTC(2020, 0, 1, parseInt(utcHour, 10), parseInt(utcMin, 10)));
                const localMin = utcDate.getMinutes();
                const localHour = utcDate.getHours();
                const localCron = `${localMin} ${localHour} ${dayOfMonth} ${month} ${dayOfWeek}`;
                return localCron;
            } else {
                console.warn("isValidCronExpression returned undefined or invalid cron");
                return false;
            }
        }
        return false;
    }


    const handleTriggerTimeBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const validationResult = isValidCronExpression(event.target.value);
        if (validationResult.isError()) {
            setIsValid(false);
        }
        else {
            setIsValid(true);
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = event.target;
        if (id === 'attributes') {
            setJsonString(value);
            try {
                const parsedJson = JSON.parse(value);
                setFormData((prevData) => ({
                    ...prevData,
                    attributes: parsedJson || {},
                }));
            } catch (e) {
                console.error(e);
            }
        } else if (!id.includes('-')) {
            setFormData((prevData) => ({
                ...prevData,
                [id]: value,
            }));
        }
    };

    return (
        <div className='schedular_container'>{
            isLoading ? <Loader /> :
                <>
                    {
                        formType == "edit" ?
                            <DefaultHeading heading='UPDATE SCHEDULAR INFO' /> :
                            <DefaultHeading heading='CREATE NEW SCHEDULAR' />
                    }
                    <form className='schedular-form'>
                        <TextField
                            color="primary"
                            label="Schedular Name"
                            type="text"
                            id="jobName"
                            value={formData.jobName || ""}
                            onChange={handleChange}
                        />
                        <TextField
                            color="primary"
                            label="Schedular Task ID"
                            type="text"
                            id="taskId"
                            value={formData.taskId || ""}
                            onChange={handleChange}
                        />
                        <TextField
                            color="primary"
                            label="Schedular Time (Local)"
                            type="text"
                            id="triggerTime-local"
                            value={convertCronToLocale(formData.triggerTime) != false ? convertCronToLocale(formData.triggerTime) : ""}
                            onChange={handleChange}
                            error={isValid !== undefined && !isValid}
                        />
                        <div>
                            <TextField
                                color="primary"
                                label="Schedular Time (UTC)"
                                type="text"
                                id="triggerTime"
                                value={formData.triggerTime || ""}
                                error={isValid !== undefined && !isValid}
                                helperText={isValid !== undefined && !isValid ? "Please enter valid cron time" : ""}
                                onChange={handleChange}
                                onBlur={handleTriggerTimeBlur}
                            />
                            <Button className="customEditTimeButton" variant="contained" onClick={() => handleEditTime()}>EDIT TIME</Button>
                        </div>
                        <TextField
                            color="primary"
                            label="Schedular Task Attribute"
                            type="text"
                            multiline
                            rows={7}
                            fullWidth
                            style={{ minHeight: '190px' }}
                            id="attributes"
                            value={jsonString || ""}
                            onChange={handleChange}
                        />
                        <TextField
                            color="primary"
                            label="Schedular Description"
                            type="text"
                            id="discription"
                            value={formData.discription || ""}
                            onChange={handleChange}
                        />
                        <Button variant="contained" onClick={() => handleCreate()}>{formType == "edit" ? "UPDATE SCHEDULAR INFO" : "CREATE SCHEDULAR"}</Button>

                    </form>

                    <div>
                        <Modal
                            open={showEditTimeForm}
                            onClose={handleClose}
                            aria-labelledby="parent-modal-title"
                            aria-describedby="parent-modal-description"
                        >
                            <Box className="centered-box" sx={{ width: 700 }}>
                                <div style={{ marginTop: '20px', zIndex: 1300, position: 'relative', overflow: 'visible' }}>
                                    <Cron value={cronExpression} setValue={setCronExpression} />
                                </div>
                                <div className='popup-buttons'>
                                    <Button onClick={timeEditConfirm} variant="contained" color="primary">
                                        Confirm
                                    </Button>
                                    <Button onClick={handleClose} variant="contained" color="primary">
                                        Cancel
                                    </Button>
                                </div>
                            </Box>
                        </Modal>
                    </div>
                </>
        }
        </div>
    )
}

export default JobsConfigurationSchedularForm